export default __webpack_public_path__ + "static/media/Ravens.b6aaee6d.png";